import { render, staticRenderFns } from "./excuses.vue?vue&type=template&id=0ca7b4d6"
import script from "./excuses.vue?vue&type=script&lang=js"
export * from "./excuses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports